import BaseService from './base';
import request from '@/utils/request';

export interface MapViewModel {
  id?: number;
  timelineItemID?: number;
  timelineItemIDs?: any[];
  name?: string;
}
export class MapService extends BaseService<MapViewModel> {
  protected serviceApi: string = 'Map';

  get NewModel(): MapViewModel {
    return {
      id: 0,
      name: '',
    };
  }
  public GetByTimeline(id: number, count: number) {
    return request({
      url: `${this.serviceApi}/GetByTimeline/${id}/${count}`,
      method: 'get',
    });
  }

}
